/* eslint-disable */
const init = () => {
	return `
	#define uParticleAttunuation 15.0
	#define M_PI 3.1415926535897932384626433832795

	// Uniforms
	uniform float uParticleSize;
	uniform vec2 uResolution;
	uniform float uTime;
	uniform float uInitialProgress;
	uniform float uDistancingRadius; // Radius of the "Person effect"
	uniform float uPersonEffectProgress; // Progress of the "Person effect"

	// Two camps effect
	uniform float uTwoCampsProgress;
	uniform float lastProgress;
	uniform float uTwoCampsColorProgress;
	uniform float uIsDividingColors;

	// Attributes
	attribute vec3 aUv;
	attribute vec2 aVertexDistortion;
	attribute float aDistortionAmplitudeX;
	attribute float aDistortionAmplitudeY;
	attribute float aRandomValue;
	attribute vec3 aColor;

	// Varying (data we send to the fragment shader)
	varying float vTestValue;
	varying vec3 vColor;
	varying float vVertexOpacity;

	/*
	Note:
	Try to use if() conditions as less as possible!
	Since it's taking more performance then using formulas logic approach
	*/

	void main() {
		/**
		* Position
		*/
		vec4 modelPosition = modelMatrix * vec4(position, 1.0);

		/*
		Calculate the position ->
		*/
		// Current dx/dy
		float pointDistanceFromCenter_x = (aUv.x - 0.5);
		float pointDistanceFromCenter_y = (aUv.y - 0.5);

		// Current angle
		float tgBeta = abs(pointDistanceFromCenter_y / pointDistanceFromCenter_x);
		float angleBeta = atan(tgBeta);
		float sinBeta = sin(angleBeta);
		float cosBeta = cos(angleBeta);

		/*
		Step 1 | Initial points approchement
		*/
		// Find a sign on X axes
		float initial_distortion_sign_x = sign(aUv.x - 0.5); // Can return -1.0 | 0.0 | 1.0
		// In case point right in the middle and initial_distortion_sign_x == 0 then set it to 1
		// To return only -1 or 1
		initial_distortion_sign_x = max(abs(initial_distortion_sign_x), 1.0) * initial_distortion_sign_x;

		// Find a sign on Y axes
		float initial_distortion_sign_y = sign(aUv.y - 0.5); // Can return -1.0 | 0.0 | 1.0
		initial_distortion_sign_y = max(abs(initial_distortion_sign_y), 1.0) * initial_distortion_sign_y;

		// Initial points gathering
		float initial_distortion_x = (1.0 - uInitialProgress) * (aDistortionAmplitudeX * cosBeta) * initial_distortion_sign_x;
		float initial_distortion_y = (1.0 - uInitialProgress) * (aDistortionAmplitudeY * sinBeta) * initial_distortion_sign_y;

		/*
		Step 2 | IDLE fluctuations
		*/
		// IDLE point distortion on X
		float distortion_x = sin(modelPosition.y + uTime * 2.0) * 0.01 * aVertexDistortion.x;
		distortion_x = distortion_x + sin(modelPosition.x + uTime * 2.0) * 0.01 * aVertexDistortion.x * aRandomValue + sin(uTime * 0.8 * modelPosition.x) * 0.005;
		// When initial distortion is finished and uInitialProgress=1.0 then step will return 1.0
		distortion_x = distortion_x * 0.5 * step(1.0, uInitialProgress);

		// IDLE point distortion on Y
		float distortion_y = cos(modelPosition.x + uTime * 2.0) * 0.01 * aVertexDistortion.y;
		distortion_y = cos(modelPosition.y + uTime * 2.0) * 0.01 * aVertexDistortion.y + cos(modelPosition.x * aRandomValue * uTime * M_PI * 2.0) * 0.005;
		// When initial
		distortion_y = distortion_y * 0.5 * step(1.0, uInitialProgress);

		/*
		Step 3 | Person effect
		*/
		// Calculate distance(if any) on which we should move point
		float currentDistanceFromCenter = distance(aUv.xy, vec2(0.5));

		// Is distance from center lower than distancing radius
		float isDistanceInferiorThanR = sign(min((currentDistanceFromCenter - uDistancingRadius), 0.0)); // Will return -1 if distance is lower and 0 if distance is greater

		float conditionalDistance_ef1 = abs(isDistanceInferiorThanR); // Will return -> 0 if distance is inferior than 0.25 and will return -> 1 if the distance from center greater than 0.25

		// Current distance to move particle (clamped between min and max value)
		float maxLimit = 0.5 - currentDistanceFromCenter;
		float minLimit = uDistancingRadius - currentDistanceFromCenter;

		// float randomValue = aUv.x;

		// float deltaAlongR = clamp(abs(uDistancingRadius - currentDistanceFromCenter), minLimit, maxLimit);
		float randomDistancingValue = abs(uDistancingRadius - currentDistanceFromCenter) + aRandomValue * 0.2;
		float deltaAlongR = clamp(randomDistancingValue, minLimit, maxLimit);

		// Move on a random distance within min and max value
		float deltaRelocation_ef1_x = deltaAlongR * cosBeta;
		float deltaRelocation_ef1_y = deltaAlongR * sinBeta;
		// float deltaRelocation_ef1_x = abs(currentDistanceFromCenter - uDistancingRadius) * cosBeta;
		// float deltaRelocation_ef1_y = abs(currentDistanceFromCenter - uDistancingRadius) * sinBeta;

		// Distance on which you should move a particle
		// float deltaRelocation_ef1_x = (aUv.x - 0.5);

		// float distortionFromInitialPosition_x = uDistancingRadius
		float delta_ef1_x = deltaRelocation_ef1_x * conditionalDistance_ef1 * sign(aUv.x - 0.5) * uPersonEffectProgress;
		float delta_ef1_y = deltaRelocation_ef1_y * conditionalDistance_ef1 * sign(aUv.y - 0.5) * uPersonEffectProgress;

		/*
		Step 4 | 2 camps effect
		*/
		vec2 o2 = vec2(step(aUv.x, 0.5), 0.5);
		float l_o2_p = distance(o2, vec2(aUv));
		float sin_o2 = (aUv.y - 0.5) / l_o2_p;
		float cos_o2 = abs(o2.x - aUv.x) / l_o2_p;
		float l_o2_a = 0.5 / cos_o2;
		float l_o2_b = sqrt(2.0 * pow(0.5, 2.0));
		float l_o2_d = 1.0 * cos_o2;
		float l_a_p = l_o2_p - l_o2_a;
		float l_a_d = l_o2_d - l_o2_a;
		float l_b_d = l_o2_d - l_o2_b;
		float l_b_c = l_a_d > 0.0 ? l_b_d * (l_a_p / l_a_d) : 0.0;
		float l_o2_c = l_o2_b + l_b_c;
		float l_p_c = l_o2_c - l_o2_p;
		float k = 1.0 + aRandomValue;
		float delta_ef2_x = l_p_c * cos_o2 * k * sign(0.5 - o2.x) * uTwoCampsProgress;
		float delta_ef2_y = l_p_c * sin_o2 * k * uTwoCampsProgress;

		/*
		FINAL DISTORTION SUMMING
		*/
		// Calculate final distortion
		modelPosition.x += distortion_x + initial_distortion_x + delta_ef1_x + delta_ef2_x;
		modelPosition.y += distortion_y + initial_distortion_y + delta_ef1_y + delta_ef2_y;

		vec4 viewPosition = viewMatrix * modelPosition;
		vec4 projectedPosition = projectionMatrix * viewPosition;

		// projectedPosition.x += sin(projectedPosition.y + uTime) * 0.01;
		// projectedPosition.y += cos(projectedPosition.x + uTime) * 0.01;

		gl_Position = projectedPosition;

		/**
		* Size
		*/
		// Particle size attenuation
		// For the init step
		float sizeAttenuation = 10.0 * distance(vec2(abs(initial_distortion_x), abs(initial_distortion_y)), vec2(1.0)) * (1.0 - uInitialProgress);
		// sizeAttenuation = 0.0;

		gl_PointSize = uParticleSize + sizeAttenuation;

		/**
		* Color
		* -------
		* Handle the color calculations which depends from the position and progress
		* 		and send it to the fragment.glsl
		*/

		// Calculate final color:

		// If vertex is placed on the left-side

		// For x inferior than 0.5 it will return 1
		// 		For x greater than 0.5 it will return 0
		float isGreenColor_logicalValue = abs(sign(min((aUv.x - 0.5), 0.0)));

		// For x inferior than 0.5 it will return 0
		// For x greater than 0.5 it will return 1
		float isRedColor_logicalValue = abs(sign(max((aUv.x - 0.5), 0.0)));

		float color_R = aColor.r / 255.0;
		float color_G = aColor.g / 255.0;
		float color_B = aColor.b / 255.0;

		float final_color_R = color_R - color_R * (uTwoCampsProgress - uTwoCampsColorProgress) * uIsDividingColors + 1.0 * isRedColor_logicalValue * (uTwoCampsProgress - uTwoCampsColorProgress) * uIsDividingColors;
		float final_color_G = color_G - color_G * (uTwoCampsProgress - uTwoCampsColorProgress) * uIsDividingColors + 1.0 * isGreenColor_logicalValue * (uTwoCampsProgress - uTwoCampsColorProgress) * uIsDividingColors;
		float final_color_B = color_B - color_B * (uTwoCampsProgress - uTwoCampsColorProgress) * uIsDividingColors;
		// float final_color_R = color_R - color_R * uTwoCampsProgress * uIsDividingColors + 1.0 * isRedColor_logicalValue * uTwoCampsProgress * uIsDividingColors;
		// float final_color_G = color_G - color_G * uTwoCampsProgress * uIsDividingColors + 1.0 * isGreenColor_logicalValue * uTwoCampsProgress * uIsDividingColors;
		// float final_color_B = color_B - color_B * uTwoCampsProgress * uIsDividingColors;

		/*
		Vertexes opacity change (from borders down to initial position)

		* Effect of appearing particles from the borders of the container
		it will be based on:
		1) calculate if vertex's position is in a limited frustrum view
		2) If it's not - then make it 0 = transparent
		3) If it is then smoothstep opacity of the vertex and send it to the fragment shader
		4) If possible then add this coefficient to the initial progress in order to make vertex "stop" on appearing
			until it will became fully visible and then move to it's position
		*/
		// New algo
		// Radius + some random area width around it
		float limitRadius = 0.5 + 0.1;

		float currentVertexPos = sqrt(pow(modelPosition.x, 2.0) + pow(modelPosition.y, 2.0));
		// float currentVertexPos = sqrt(pow((modelPosition.x + distortion_x + initial_distortion_x), 2.0) + pow((modelPosition.y + distortion_y + initial_distortion_y), 2.0));

		// sqrt(pow(modelPosition.x, 2.0) + pow(modelPosition.y, 2.0))
		// When progress hits 1.0 then limitDeltaOpacityK should be 1.0!
		float vertexOpacity = smoothstep(0.0, 1.0, pow(limitRadius / currentVertexPos, 2.0));

		vColor = vec3(final_color_R, final_color_G, final_color_B);

		// vInitialProgress = uInitialProgress;
		// vInitialDistortion = isVertexOutFrustrumViewBool;
		// vInitialDistortion = isVertexInFrustrumViewBool;
		vVertexOpacity = vertexOpacity;
		// vTestValue = conditionalDistance_ef2;
		// vTestValue = minLimit_ef2 * conditionalDistance_ef2;
	}
	`;
};


export default {
	init,
};
/* eslint-enable */
